import { Route, Routes } from 'react-router-dom';
import { PagesPage } from './PagesPage';
import { ModifyPagePage } from './ModifyPagePage';

export const PagesPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifyPagePage />} />
    <Route path='/:slug' element={<ModifyPagePage />} />
    <Route path='*' element={<PagesPage />} />
  </Routes>
);
